import { useCallback, useState } from "react";
import { useDispatch } from 'react-redux';
import { change_password_saga, set_password_saga } from "../../store/actions/my-info";

const changePasswordHook = (props) => {
    const dispatch = useDispatch();
    const [oldPassword, setOldPassword] = useState({value:"", valid:false});
    const [password, setPassword] = useState({value:"", valid:false});
    const [submited, setSubmited] = useState(false);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const keyPress = (e) => {
        if (e.key === "Enter") {
            change_password()
        }
    }
    const change_password = useCallback(() => {
        setSubmited(true);
        if (password.valid && oldPassword.valid) {
            setLoading(true);
            dispatch(change_password_saga({
                old_password:oldPassword.value,
                new_password:password.value,
                token: props.token,
                cb: () => setLoading(false),
                cbChanged: () => {
                    setLoading(false);
                    setOpen(false)
                }
            }))
        }
    }, [password,oldPassword])
    const set_password = useCallback(() => {
        setSubmited(true);
        if (password.valid) {
            setLoading(true);
            dispatch(set_password_saga({
                password:password.value,
                token: props.token,
                cb: () => setLoading(false),
                cbChanged: () => {
                    setLoading(false);
                    setOpen(false)
                }
            }))
        }
    }, [password])
    const enterOldPassword = useCallback((value) => setOldPassword(value), [])
    const enterPassword = useCallback((value) => setPassword(value), [])
    const handleOpen = useCallback(() => setOpen(true), [])
    const handleClose = useCallback(() => setOpen(false), [])
    const handleSubmited = useCallback(() => setSubmited(!submited), [submited])
    return {
        enterOldPassword,
        enterPassword,
        change_password,
        keyPress,
        handleOpen,
        handleClose,
        handleSubmited,
        set_password,
        submited,
        loading,
        oldPassword,
        password,
        open
    }
}
export default changePasswordHook;